import React from 'react';
import { Box } from '@mui/material';

interface ValidadoLogoProps {
  width?: number;
  height?: number;
  sx?: any;
}

const ValidadoLogo: React.FC<ValidadoLogoProps> = ({
  width = 200,
  height = 80,
  sx = {},
  ...props
}) => {
  return (
    <Box sx={sx} {...props}>
      <img
        src={`${process.env.PUBLIC_URL}/logo-validado-20260803.png`}
        alt="Valida.do Logo"
        style={{
          width: width,
          height: height,
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default ValidadoLogo;
